/**
 * @internal
 */ function getClientArgs(queryKey, opts, pageParam) {
    const path = queryKey[0];
    let input = queryKey[1]?.input;
    if (pageParam) {
        input = {
            ...input ?? {},
            cursor: pageParam
        };
    }
    return [
        path.join('.'),
        input,
        opts?.trpc
    ];
}

export { getClientArgs };
